export const version = "units/5.0.8";
//# sourceMappingURL=_version.js.map